import { useSession } from '@/context/session/useSession';
import { Avatar, AvatarFallback, AvatarImage } from '../../ui/Avatar';

export default function UserAvatar() {
  const { session } = useSession();

  const avatarUrl = session?.user.user_metadata.avatar_url;
  const email = session?.user.email;

  return (
    <Avatar>
      <AvatarImage src={avatarUrl} />
      <AvatarFallback className="bg-primary-purple text-white text-xl">
        {email?.charAt(0).toUpperCase()}
      </AvatarFallback>
    </Avatar>
  );
}
